module.exports = __webpack_public_path__ + "img/7.230e9ef8.png";